export default {
	state: {
		courier_company_selection: {},
		warehouse_selection: {},
		epo_status_selection: {},
	},
	mutations: {
		SET_COURIER_COMPANY_SELECTION_CACHE(state, { country_id, data, }) {
			state.courier_company_selection[`courier_company_${country_id}`] = {
				data,
				timestamp: Date.now()
			};
		},
		CLEAR_COURIER_COMPANY_CACHE(state, country_id = null) {
			if (country_id) {
				delete state.courier_company_selection[`courier_company_${country_id}`];
			} else {
				state.courier_company_selection = {};
			}
		},
		SET_WAREHOUSE_SELECTION_CACHE(state, { cache_name, data, }) {
			state.warehouse_selection[cache_name] = {
				data,
				timestamp: Date.now()
			};
		},
		CLEAR_WAREHOUSE_SELECTION_CACHE(state, cache_name = null) {
			if (cache_name) {
				delete state.warehouse_selection[cache_name];
			} else {
				state.warehouse_selection = {};
			}
		},
		SET_EPO_STATUS_SELECTION(state, { data, }) {
			state.epo_status_selection = {
				data,
				timestamp: Date.now()
			};
		},
		CLEAR_EPO_SELECTION_SELECTION_CACHE(state) {
			state.epo_status_selection = {};
		}
	},
	getters: {
		getCourierCompanySelectionCache: (state) => (country_id) => {
			const cached = state.courier_company_selection[`courier_company_${country_id}`];
			if (!cached) return null;

			// Optional: Check if cache is expired (1 hour)
			if (Date.now() - cached.timestamp > 3600000) {
				return null;
			}
			return cached.data;
		},
		getWarehouseSelectionCache: (state) => (cache_name) => {
			const cached = state.warehouse_selection[cache_name];
			if (!cached) return null;

			// Optional: Check if cache is expired (1 hour)
			if (Date.now() - cached.timestamp > 3600000) {
				return null;
			}
			return cached.data;
		},
		getEpoStatusSelection: (state) => () => {
			const cached = state.epo_status_selection;
			if (!cached) return null;

			// Optional: Check if cache is expired (1 hour)
			if (Date.now() - cached.timestamp > 3600000) {
				return null;
			}
			return cached.data;
		}
	},
	actions: {
		async cacheCourierCompanySelection({ commit }, { country_id, data }) {
			commit('SET_COURIER_COMPANY_SELECTION_CACHE', { country_id, data });
		},
		async clearCacheCourierCompanySelection({ commit }, country_id) {
			commit('CLEAR_COURIER_COMPANY_CACHE', country_id);
		},
		async cacheWarehouseSelection({ commit }, { cache_name, data }) {
			commit('SET_WAREHOUSE_SELECTION_CACHE', { cache_name, data });
		},
		async clearCacheWarehouseSelection({ commit }, cache_name) {
			commit('CLEAR_WAREHOUSE_SELECTION_CACHE', cache_name);
		},
		async cacheEpoStatusSelection({ commit }, { data }) {
			commit('SET_EPO_STATUS_SELECTION', { data });
		},
		async clearCacheEPOSelection({ commit }, cache_name) {
			commit('CLEAR_EPO_SELECTION_SELECTION_CACHE', cache_name);
		}
	}
}